import React from 'react';
import PropTypes from 'prop-types';
import { PaperclipIcon } from '../../model/icons';
import FilePreview from './FilePreview';

const ACCEPT = 'image/*,video/*,audio/*,.pdf,.doc,.docx';

// Зона прикрепления файлов (.bc-drop) + превью выбранных.
export default function FileDropzone({ files, onAdd, onRemove }) {
    const handleChange = (e) => {
        const selected = Array.from(e.target.files || []);
        if (selected.length) onAdd(selected);
        e.target.value = '';
    };

    return (
        <div className="bc-field">
            <label className="ctl-label">Прикрепить файлы (до 10 шт)</label>
            <label className="bc-drop">
                <PaperclipIcon />
                Нажмите для выбора файлов
                <input type="file" multiple accept={ACCEPT} onChange={handleChange} style={{ display: 'none' }} />
            </label>
            {files.length > 0 && (
                <div className="bc-files">
                    {files.map((file, index) => (
                        <FilePreview key={`${file.name}-${file.size}-${file.lastModified}`} file={file} onRemove={() => onRemove(index)} />
                    ))}
                </div>
            )}
        </div>
    );
}

FileDropzone.propTypes = {
    files: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired
};
